<template>
  <div>
    <custom-actions title="已预约">
      <el-form :model="searchForm" ref="searchForm2" inline class="global-form-label-width account-form"
        label-width="100px">
        <el-form-item prop="plannedDate" label="计划入场日期">
          <el-date-picker v-model="searchForm2.plannedDate" placeholder="请选择计划入场日期" type="date" clearable
            format="yyyy-MM-dd" value-format="yyyy-MM-dd"></el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSearch('2')">查询</el-button>
          <el-button @click="onReset('searchForm2')">重置</el-button>
        </el-form-item>
      </el-form>
    </custom-actions>

    <el-card shadow="never" class="mt10">
      <el-tabs v-model="activeName" @tab-click="changePlayType">
        <el-tab-pane :label="item[1]" :name="item[0]" v-for="(item, index) of Array.from(planTypeMap)"
          :key="index"></el-tab-pane>
      </el-tabs>
      <!-- 只有出库的时候才显示统计数据 -->
      <el-row class="mb15" v-if="ygType === 'A'">
        <el-col :span="4">最大出货量：{{ info.planNum || '0' }}</el-col>
        <el-col :span="4">
          <div style="display: flex;align-items: center;">
            <span>
              已约出货量：
            </span>
            <!-- <span class="text-view">{{ info.yyPlanNum || '0' }}</span> -->
            <el-button :disabled="!(parseFloat(info.yyPlanNum) > 0)" style="padding: 0;text-decoration: underline;"
              class="ml10" type="text" @click="loadGgList(searchForm2.plannedDate)">{{ info.yyPlanNum || '0'
              }}</el-button>
          </div>
        </el-col>
        <el-col :span="4">早餐数量：{{ info.yyMealNum2 || '0' }}</el-col>
        <el-col :span="4">午餐数量：{{ info.yyMealNum3 || '0' }}</el-col>
        <el-col :span="4">晚餐数量：{{ info.yyMealNum4 || '0' }}</el-col>
      </el-row>
      <el-table key="123" v-if="activeName === '1'" size="mini" stripe border v-loading="loading" :cell-style="tableCellStyle" :data="tableData2">
        <el-table-column min-width="130" align="center" fixed="left" label="时间段" prop="timeslotVal"></el-table-column>
        <el-table-column label="小车" align="center">
          <el-table-column prop="xcKh" min-width="140" show-overflow-tooltip align="center"
            label="客户"></el-table-column>
          <el-table-column min-width="120" align="center" prop="" label="车牌号">
            <template v-slot="{ row }">
              {{ row.xcNumber || '--' }}
            </template>
          </el-table-column>
          <el-table-column min-width="110" align="center" prop="" label="数量">
            <template v-slot="{ row }">
              <div v-if="row.xcSl" style="display: flex;justify-content: center;align-items: center;">
                <el-button type="text" @click="loadGgList(row.xcId)">{{ row.xcSl || '--' }}</el-button>
              </div>
            </template>
          </el-table-column>
          <el-table-column min-width="110" align="center" prop="" label="司机报餐">
            <template v-slot="{ row }">
              {{ isMealFormatMap.get(row.xcMe) || '--' }}
            </template>
          </el-table-column>
          <el-table-column min-width="130" align="center" prop="" label="状态">
            <template v-slot="{ row }">
              <span>{{ arrivalStatusMap.get(row.xcZt) || '--' }}</span>
              <span v-if="row.xcRe === '3'">(已完成)</span>
            </template>
          </el-table-column>
          <el-table-column width="120" align="center" label="操作">
            <template v-slot="{ row }">
              <el-button v-if="hasCancel && row.xcRe !== '3' && row.xcNumber" type="text"
                @click="cancelArrival(row.xcId)">取消</el-button>
              <el-button v-if="row.xcNumber" type="text"
                @click=" $router.push('/entryplan/detail?planId=' + row.xcId)">详情</el-button>
            </template>
          </el-table-column>
        </el-table-column>
        <el-table-column label="大车" align="center">
          <el-table-column prop="dcKh" min-width="140" show-overflow-tooltip align="center"
            label="客户"></el-table-column>
          <el-table-column min-width="120" align="center" prop="" label="车牌号">
            <template v-slot="{ row }">
              {{ row.dcNumber || '--' }}
            </template>
          </el-table-column>
          <el-table-column min-width="120" align="center" prop="" label="数量">
            <template v-slot="{ row }">
              <div v-if="row.dcSl" style="display: flex;justify-content: center;align-items: center;">
                <el-button type="text" @click="loadGgList(row.dcId)">{{ row.dcSl || '--' }}</el-button>
              </div>
            </template>
          </el-table-column>
          <el-table-column min-width="120" align="center" prop="" label="司机报餐">
            <template v-slot="{ row }">
              {{ isMealFormatMap.get(row.dcMe) || '--' }}
            </template>
          </el-table-column>
          <el-table-column min-width="140" align="center" prop="" label="状态">
            <template v-slot="{ row }">
              <span>{{ arrivalStatusMap.get(row.dcZt) || '--' }}</span>
              <span v-if="row.dcRe === '3'">(已完成)</span>
            </template>
          </el-table-column>
          <el-table-column width="120" align="center" label="操作">
            <template v-slot="{ row }">
              <el-button v-if="hasCancel && row.dcRe !== '3' && row.dcNumber" type="text"
                @click="cancelArrival(row.dcId)">取消</el-button>
              <el-button v-if="row.dcNumber" type="text"
                @click=" $router.push('/entryplan/detail?planId=' + row.dcId)">详情</el-button>
            </template>
          </el-table-column>
        </el-table-column>
      </el-table>
      <el-table key="456" v-if="activeName === '2'" size="mini" stripe border v-loading="loading" :cell-style="tableCellStyle" :data="tableData2">
        <el-table-column min-width="130" align="center" fixed="left" label="时间段" prop="timeslotVal"></el-table-column>
        <el-table-column label="罐车" align="center">
          <el-table-column prop="gcKh" min-width="140" show-overflow-tooltip align="center"
            label="客户"></el-table-column>
          <el-table-column min-width="120" align="center" prop="" label="车牌号">
            <template v-slot="{ row }">
              {{ row.gcNumber || '--' }}
            </template>
          </el-table-column>
          <el-table-column min-width="110" align="center" prop="" label="数量">
            <template v-slot="{ row }">
              <div v-if="row.gcSl" style="display: flex;justify-content: center;align-items: center;">
                <el-button type="text" @click="loadGgList(row.gcId)">{{ row.gcSl || '--' }}</el-button>
              </div>
            </template>
          </el-table-column>
          <el-table-column min-width="110" align="center" prop="" label="司机报餐">
            <template v-slot="{ row }">
              {{ isMealFormatMap.get(row.gcMe) || '--' }}
            </template>
          </el-table-column>
          <el-table-column min-width="130" align="center" prop="" label="状态">
            <template v-slot="{ row }">
              <span>{{ arrivalStatusMap.get(row.gcZt) || '--' }}</span>
              <span v-if="row.gcRe === '3'">(已完成)</span>
            </template>
          </el-table-column>
          <el-table-column width="120" align="center" label="操作">
            <template v-slot="{ row }">
              <el-button v-if="hasCancel && row.gcRe !== '3' && row.gcNumber" type="text"
                @click="cancelArrival(row.gcId)">取消</el-button>
              <el-button v-if="row.gcNumber" type="text"
                @click=" $router.push('/entryplan/detail?planId=' + row.gcId)">详情</el-button>
            </template>
          </el-table-column>
        </el-table-column>
      </el-table>
    </el-card>

    <custom-actions title="未预约" class="mt10">
      <template #header>
        <el-button type="primary" v-if="hasAdd" @click="$router.push('/entryplan/add?ygType=' + ygType)">新增</el-button>
      </template>
      <el-form :model="searchForm" ref="searchForm" inline class="global-form-label-width account-form"
        label-width="100px">
        <el-form-item prop="plateNumber" label="车牌号">
          <el-input v-model="searchForm.plateNumber" placeholder="请输入车牌号" />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSearch('1')">查询</el-button>
          <el-button @click="onReset('searchForm')">重置</el-button>
        </el-form-item>
      </el-form>
    </custom-actions>

    <el-card shadow="never" class="mt10">
      <el-table size="mini" stripe border v-loading="loading" :data="tableData">
        <el-table-column min-width="120" label="关联工单号" prop="orderNumber"></el-table-column>
        <el-table-column min-width="120" label="关联客户" prop="userName"></el-table-column>
        <el-table-column min-width="120" label="车牌号" prop="plateNumber"></el-table-column>
        <el-table-column min-width="120" label="挂车号" prop="vehicleGph"></el-table-column>
        <el-table-column min-width="120" label="司机姓名" prop="driverName"></el-table-column>
        <el-table-column min-width="120" label="司机手机号" prop="driverPhone"></el-table-column>
        <el-table-column min-width="160" label="司机身份证" prop="driverId"></el-table-column>
        <el-table-column min-width="120" label="车辆类型" prop="vehicleType">
          <template v-slot="{ row }">
            {{ vehicleTypeMap.get(row.vehicleType) || '--' }}
          </template>
        </el-table-column>
        <el-table-column min-width="120" label="计划数量" prop="plannedNum">
          <template v-slot="{ row }">
            <div style="display: flex;;align-items: center;">
              <el-button type="text" @click="loadGgList(row.planId)">{{ row.plannedNum || '--' }}</el-button>
            </div>
          </template>
        </el-table-column>
        <el-table-column min-width="120" label="可预约时间段" prop="">
          <template v-slot="{ row }">
            {{ row.vehicleDateStart }} 至 {{ row.vehicleDateEnd || '--' }}
          </template>
        </el-table-column>

        <!-- <el-table-column min-width="120" label="计划入场日期" prop="plannedDate"></el-table-column>
        <el-table-column min-width="140" label="计划入场时间段" prop="timeslotVal"></el-table-column>
        <el-table-column min-width="120" label="预约状态" prop="reservationStatus">
          <template v-slot="{ row }">
            {{ reservationStatusMap.get(row.reservationStatus) || '--' }}
          </template>
        </el-table-column>
        <el-table-column min-width="120" label="签到时间" prop="arrivalTime">
        </el-table-column> -->
        <!-- <el-table-column min-width="120" label="到达状态" prop="arrivalStatus">
          <template v-slot="{ row }">
            {{ arrivalStatusMap.get(row.arrivalStatus) || '--' }}
          </template>
        </el-table-column> -->

        <el-table-column width="180" label="操作" fixed="right">
          <template v-slot="{ row }">
            <el-button type="text" @click="$router.push('/entryplan/detail?planId=' + row.planId)">详情</el-button>
            <el-button type="text" v-if="hasEdit"
              @click="$router.push('/entryplan/edit?planId=' + row.planId)">编辑</el-button>
            <el-button v-if="hasDel" type="text" @click="deleteRow(row.planId)" class="del-btn">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination class="mt15" :current-page.sync="page" background layout="total, prev, pager, next" :total="total"
        @current-change="loadData">
      </el-pagination>
    </el-card>

    <el-dialog title="入场规格清单" :visible.sync="guigeVisible" width="800px">
      <el-table size="mini" stripe border v-loading="loading" :data="planGgList">
        <el-table-column min-width="180" label="规格名称" prop="specName"></el-table-column>
        <el-table-column min-width="120" label="规格单位" prop="unit"></el-table-column>
        <el-table-column min-width="120" label="计划数量" prop="planQuantity"></el-table-column>
        <el-table-column min-width="120" label="发货数量" prop="pickupQuantity"></el-table-column>
        <el-table-column min-width="120" label="到货数量" prop="arrivalQuantity"></el-table-column>
      </el-table>
    </el-dialog>

  </div>
</template>

<script>
import keepAlive from '@/mixins/keepAlive'
import { vehicleType, reservationStatus, arrivalStatus, isMealFormat, planType } from '@/utils/dict'

export default {
  name: 'EntryPlan',
  mixins: [keepAlive],

  data() {
    return {
      activeName: '1',
      planTypeMap: planType,
      guigeVisible: false,
      vehicleTypeMap: vehicleType,
      reservationStatusMap: reservationStatus,
      arrivalStatusMap: arrivalStatus,
      isMealFormatMap: isMealFormat,
      tableData: [],
      planGgList: [],
      page: 1,
      total: 0,
      loading: false,
      searchForm: {
        plateNumber: '',
        reservationStatus: '1'
      },
      tableData2: [],
      searchForm2: {
        plannedDate: ''
      },
      info: {
        planNum: '0', // 计划产能
        yyPlanNum: '0', // 已约出货量
        yyMealNum: '0',
        yyMealNum2: '0', // 已约早餐量
        yyMealNum3: '0', // 已约午餐量
        yyMealNum4: '0' // 已约晚餐量
      }
    }
  },
  computed: {
    buttonList() {
      return this.$store.state.buttonList.map(item => item.butCode)
    },
    hasAdd() {
      return this.buttonList.includes('add')
    },
    hasEdit() {
      return this.buttonList.includes('edit')
    },
    hasDel() {
      return this.buttonList.includes('delete')
    },
    hasCancel() {
      return this.buttonList.includes('cancel')
    },
    ygType() {
      return this.$route.query.ygType
    }
  },
  watch: {
    ygType() {
      this.searchForm2.plannedDate = this.$dayjs().format('YYYY-MM-DD')
      this.searchForm.plateNumber = ''
      this.loadData()
      this.loadData2()
    }
  },
  created() {
    this.searchForm2.plannedDate = this.$dayjs().format('YYYY-MM-DD')
    this.loadData()
    this.loadData2()
  },
  methods: {
    changePlayType() {
      this.loadData()
      this.loadData2()
    },
    checkExpired(timeslotVal) {
      const data = timeslotVal.match(/\((.*?)\)(\d{2}:\d{2})~(\d{2}:\d{2})/)
      let currentTime = this.$dayjs(this.searchForm2.plannedDate + ' ' + data[3])
      if (data[1] === '次日') {
        currentTime = currentTime.add(1, 'day')
      }
      return currentTime.isBefore(this.$dayjs())
    },
    loadGgList(planId) {
      this.$axios.get(this.$apis.clyy.selectWlVehiclePlanGg, {
        planId
      }).then(res => {
        this.planGgList = res || []
        this.guigeVisible = true
      })
    },
    tableCellStyle({ row, column, rowIndex, columnIndex }) {
      if (row.xcNumber && row.xcZt === '1' && this.checkExpired(row.timeslotVal) && columnIndex >= 1 && columnIndex <= 5) {
        return {
          background: '#F56C6C',
          color: '#FFFFFF'
        }
      }
      if (row.dcNumber && row.dcZt === '1' && this.checkExpired(row.timeslotVal) && columnIndex >= 7 && columnIndex <= 11) {
        return {
          background: '#F56C6C',
          color: '#FFFFFF'
        }
      }
    },
    cancelArrival(planId) {
      this.$confirm('确认取消该预约吗, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post(this.$apis.clyy.editWlVehiclePlanQx, {
          planId
        }).then(() => {
          this.loadData2()
          this.loadData()
        })
      })
    },
    deleteRow(planId) {
      this.$confirm('确认删除该记录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post(this.$apis.clyy.deleteDataWlVehiclePlan, {
          planId
        }).then(() => {
          this.loadData()
        })
      })
    },
    loadData() {
      this.$axios.get(this.$apis.clyy.selectWlVehiclePlanByPage, {
        ...this.searchForm,
        page: this.page,
        size: 10,
        planType: this.activeName,
        ygType: this.ygType
      }).then(res => {
        this.tableData = res.list
        this.total = res.total
      })
    },
    loadData2() {
      this.$axios.get(this.$apis.clyy.selectWlVehicleDayByList2, {
        ...this.searchForm2,
        planType: this.activeName,
        ygType: this.ygType
      }).then(res => {
        this.tableData2 = res || []
        this.loadCount()
      })
    },
    loadCount() {
      this.$axios.get(this.$apis.clyy.selectWlVehicleDateByPage, {
        dateDay: this.searchForm2.plannedDate,
        planType: this.activeName
      }).then(res => {
        if (res && res.list && res.list.length) {
          this.info = res.list[0]
        } else {
          this.info = {
            planNum: '0', // 计划产能
            yyPlanNum: '0', // 已约出货量
            yyMealNum: '0',
            yyMealNum2: '0', // 已约早餐量
            yyMealNum3: '0', // 已约午餐量
            yyMealNum4: '0' // 已约晚餐量
          }
        }
      })
    },
    onSearch(type) {
      if (type === '1') {
        this.page = 1
        this.loadData()
      } else {
        this.loadData2()
      }
    },
    onReset(formName) {
      this.$refs[formName].resetFields()
    }
  }
}
</script>
<style lang="scss" scoped>
.text-view {
  color: #0e6ad7;
  text-decoration: underline;
  cursor: pointer;
}
</style>
